import React, { useState } from "react";
import { Input, Select, Row, Col } from "antd";

const { Option } = Select;

export const InputSelect = ({ value = {}, onChange, config, onSearch, selectList, onInputSelectChange }) => {
    const [input, setInput] = useState();
    const [select, setSelect] = useState();
    let {
        idKey,
        valueKey,
        showSearch,
        mode,
        allowClear,
        disabled,
        together,
        inputCol,
        selectCol,
        maxLength,
        placeholder,
    } = config;
    let optionKey = valueKey ? valueKey : "name";
    let optionValue = idKey ? idKey : "id";
    const triggerChange = changedValue => {
        onChange?.({
            input,
            select,
            ...value,
            ...changedValue,
        });
    };

    const onInputChange = e => {
        let newInput = e.target.value.trim();
        if (!("input" in value)) {
            setInput(newInput);
        }
        triggerChange({
            input: newInput,
        });
        onInputSelectChange(newInput, {}, "inputChange");
    };

    const onSelectChange = (newSelect, option) => {
        if (!("select" in value)) {
            setSelect(newSelect);
        }
        triggerChange({
            select: newSelect,
        });
        onInputSelectChange(newSelect, option, "selectChange");
    };

    return (
        <Row>
            <Col span={inputCol?.span || 12} offset={inputCol?.offset || 0}>
                <Input
                    type="text"
                    value={value.input || input}
                    onChange={onInputChange}
                    disabled={disabled}
                    maxLength={maxLength}
                    placeholder={placeholder}
                />
            </Col>
            <Col span={selectCol?.span || 12} offset={selectCol?.offset || 0}>
                <Select
                    value={value.select || select}
                    mode={mode || ""}
                    allowClear={allowClear || false}
                    showSearch={showSearch || false}
                    onSearch={showSearch && (value => onSearch && onSearch(value))}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onChange={onSelectChange}
                    disabled={disabled}>
                    {(selectList || []).map((it, index) => {
                        return (
                            <Option key={index} value={it[optionValue]} data={it}>
                                {together ? `${it.id}:${it[optionKey]}` : it[optionKey]}
                            </Option>
                        );
                    })}
                </Select>
            </Col>
        </Row>
    );
};
